import * as TYPES from './_store/types';
import { usePageStore } from '@/store';
export async function asyncData(store) {
    const pageStore = usePageStore(this.$pinia);

    const axios = this.axiosIns;
    const agentId = this.agentId === undefined ? -1 : this.agentId;
    store[TYPES.SET_AGENT_ID](agentId);

    // agent
    let agentRes = {};
    if (isValidAgent()) {
        agentRes = await axios.post('/api-graphql', {
            query: `{agent(id: ${agentId}){fullName,image,phone,position,externalUrl,license,longIntroduction,headShots{photoFiveByThree,photoOneByOne,photoThreeByFour},email,socialNetworks:agentSocialNetworks{id,url,socialNetwork}}}`
        });
        store[TYPES.SET_AGENT]((agentRes.data && agentRes.data.agent) || {});
    }

    function isValidAgent() {
        return agentId !== null && agentId != -1;
    }

    return Promise.all([this.getTestimonials(), this.getLatestMoreLink(), pageStore.getCompanyInfo()]);
}
